import { Button, Form, Input, Space } from "antd";
import { useEffect } from "react";
import WarningImg from "../../../assets/images/warning.svg";
import useModal from "../../../hooks/useModal";
import { toast } from "../../../lib/toast";
import { IWifi } from "../../../pages/admin/Settings/OfficeSettings/Operational";
import { ModalComponentProps } from "../../../types";
import { generateUUID } from "../../../utils/number";
import CustomModal from "../../ui/CustomModal";

interface ManageWifiModalProps
  extends ModalComponentProps<
    { data: IWifi; idx: number },
    "ADD_WIFI" | "UPDATE_WIFI"
  > {
  handleManage: (val: IWifi, idx?: number) => void;
}

export default function ManageWifi({
  handleClose,
  handleManage,
  data,
  type,
  ...rest
}: ManageWifiModalProps) {
  const [form] = Form.useForm();
  const { open, handleOpen, handleClose: handleNestedModalClose } = useModal();

  // const onFinish = (values: any) => {
  //   handleManage(
  //     {
  //       ...values,
  //       id: data?.data?.id || generateUUID(),
  //       action: type === "ADD_WIFI" ? "add" : "edit",
  //     },
  //     data?.idx
  //   );
  //   handleClose();
  // };

  const onFinish = (values: any) => {
    const actionType = type === "ADD_WIFI" ? "add" : "edit";

    handleManage(
      {
        ...values,
        id: data?.data?.id || generateUUID(),
        action: actionType,
      },
      data?.idx
    );

    // Show toast notification based on action type
    if (actionType === "add") {
      toast("success", "Successfully Added!");
    } else {
      toast("success", "Successfully Updated!");
    }

    handleClose();
  };

  useEffect(() => {
    if (type === "UPDATE_WIFI" && Object.keys(data?.data || {})?.length) {
      form.setFieldsValue({
        office_name: data?.data?.office_name,
        ip: data?.data?.ip,
      });
    }
  }, [data?.data, form, type]);

  return (
    <CustomModal
      title={type === "UPDATE_WIFI" ? "Update Wifi" : "Add Wifi"}
      {...rest}
      handleClose={handleClose}
      width={460}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          name="office_name"
          label="Name"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please enter name",
            },
          ]}
        >
          <Input size="large" placeholder="Enter name" />
        </Form.Item>
        <Form.Item
          name="ip"
          label="Wifi IP"
          className="mb-1"
          rules={[
            {
              required: true,
              message: "Please enter wifi IP",
            },
            {
              pattern:
                /^(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/,
              message: "Invalid IP format",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="Ex: 192.168.31.32"
            className="w-full"
          />
        </Form.Item>

        <p
          className="text-accent text-sm font-medium cursor-pointer inline-block"
          onClick={() => {
            handleOpen({ type: "VIEW" });
          }}
        >
          Give public static IP
        </p>

        <Space className="w-full mt-6 mb-1.5" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
          >
            {type === "UPDATE_WIFI" ? "Update" : "Add"}
          </Button>
        </Space>
      </Form>

      {open.type == "VIEW" && (
        <CustomModal
          open={open.open}
          title=""
          handleClose={handleNestedModalClose}
          width={450}
          footer={null}
        >
          <div className="text-center">
            <img src={WarningImg} alt="" className="mx-auto" />
            <div className="font-semibold text-2xl my-4">
              Give Public Static IP
            </div>
            <div>
              Please input your Public Static IP which is not changeable and
              dedicated for your company. Go to this link{" "}
              <a
                className="underline text-blue-500"
                href="https://api64.ipify.org/"
                target="_blank"
                rel="noreferrer"
              >
                What’s My IP
              </a>{" "}
              to find your current network IP and cross check with your Internet
              service provider (ISP) if it's a public static IP or not.
            </div>

            <Button className="mt-4" onClick={() => handleNestedModalClose()}>
              Close
            </Button>
          </div>
        </CustomModal>
      )}
    </CustomModal>
  );
}
